import React from "react"
import CustomPageHeader from "../fragments/CustomPageHeader"

export default function Users({ children }) {
  return (
    <div>
      <CustomPageHeader icon='users' text='Users' />
      { children }
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Users/index.js